module.exports = __webpack_public_path__ + "static/assets/edd3014da582ab3635dca5a05669a3f9.png";